export default "__VITE_ASSET__CaVopy$K__"